<template>
  <div class="labeled-list-media">
    <Media :resource="resource" />
  </div>
</template>

<script>
import editable from '@i22/frontend-cms-utils/mixins/editable'
import Media from 'beisheim/components/blocks/media'

export default {
  components: {
    Media
  },
  mixins: [editable]
}
</script>

<style lang="scss">
  .labeled-list-media {
    .media {
      margin-top: 5rem;
      margin-bottom: 5rem;
    }
  }
</style>
